import Multiselect from "multiselect-react-dropdown";
import { useEffect, useState } from "react";
import Editor from 'react-simple-wysiwyg';
import {
  Col,
  Collapse,
  Container,
  Form,
  InputGroup,
  Offcanvas,
  Row,
  Table,
} from "react-bootstrap";
import { IoMdAddCircleOutline } from "react-icons/io";
import { RiDeleteBin6Line } from "react-icons/ri";
import { TbLogicAnd } from "react-icons/tb";
import { GiLogicGateAnd } from "react-icons/gi";
import { MdDisabledVisible } from "react-icons/md";
import { FaRegCheckCircle } from "react-icons/fa";
import { globalFormManagementServices } from "../../../../APIServices/globalFormManagementServices";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const FormCustomization = ({
  Show,
  Hide,
  fieldData,
  formId,
  handleUpdateFormField,
  setFormFields,
  formFields,
  setActiveTab,
  activeTab,
  formMetadataList,
  conditionaLogicTab,
  setConditionaLogicTab,
  formCategory,
  domainCode,
  domainLabel,
  formType,
  studyId,
  conditional,
  customForm
}) => {
  const [optionId, setOptionId] = useState("")
  const [selectedItems, setSelectedItems] = useState([])
  const [formKeyList, setFormKeyList] = useState([]);
  const [formFieldGroupList, setFormFieldGroupList] = useState([]);
  const [formFieldGroup, setFormFieldGroup] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChangeFormFieldGroup = (categoryId) => {
    setFormFieldGroup(categoryId)
    let fieldgroupData = formFieldGroupList?.find(item => item.categoryId === categoryId)
    handleUpdateFormField(fieldData?.id, "categoryLabel", fieldgroupData?.categoryLabel)
    handleUpdateFormField(fieldData?.id, "categoryName", fieldgroupData?.categoryName)
    handleUpdateFormField(fieldData?.id, "categoryCodeLabel", fieldgroupData?.categoryCodeLabel)
    handleUpdateFormField(fieldData?.id, "categoryCodeName", fieldgroupData?.categoryCodeName)
    handleUpdateFormField(fieldData?.id, "categoryValueLabel", fieldgroupData?.categoryValueLabel)
    handleUpdateFormField(fieldData?.id, "categoryValueName", fieldgroupData?.categoryValueName)
    handleUpdateFormField(fieldData?.id, "categoryUnitLabel", fieldgroupData?.categoryUnitLabel)
    handleUpdateFormField(fieldData?.id, "categoryUnitName", fieldgroupData?.categoryUnitName)
    handleUpdateFormField(fieldData?.id, "categoryRemarkLabel", fieldgroupData?.categoryRemarkLabel)
    handleUpdateFormField(fieldData?.id, "categoryRemarkName", fieldgroupData?.categoryRemarkName)
  }

  const getGlobalFormFieldGroup = async (e) => {
    let data = await globalFormManagementServices.getGlobalFormFieldGroup(
      "active",
    );
    setFormFieldGroupList(data?.data || []);
  };


  const getStudyLevelFormBasedOnFieldKey = async (e) => {
    setLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelFormBasedOnFieldKey(
      formType,
      studyId,
      formId,
      fieldData?.fieldName
    );
    if (fieldData?.fieldName) {
      setFormKeyList(data?.data || []);
    } else {
      setFormKeyList([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (fieldData?.fieldName) {
      getStudyLevelFormBasedOnFieldKey();
    }
  }, [formCategory, formType, formId, fieldData?.fieldName]);

  useEffect(() => {
    getGlobalFormFieldGroup()
  }, []);

  const addUnitOption = () => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          const newOption = {
            id: Math.floor(1000000000 + Math.random() * 9000000000),
            option: `Unit Option ${field.unitOptions?.length + 1 || 1}`
          };
          return {
            ...field,
            unitOptions: [...(field.unitOptions || []), newOption]
          };
        }
        return field;
      })
    );
  };

  const deleteUnitOption = (optionId) => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          return {
            ...field,
            unitOptions: field.unitOptions.filter(opt => opt.id !== optionId)
          };
        }
        return field;
      })
    );
  };

  const editUnitOption = (optionId, newValue) => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          return {
            ...field,
            unitOptions: field.unitOptions.map(opt =>
              opt.id === optionId ? { ...opt, option: newValue } : opt
            )
          };
        }
        return field;
      })
    );
  };

  const addOption = () => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          const newOption = {
            id: Math.floor(1000000000 + Math.random() * 9000000000),
            option: `Option ${field.options?.length + 1 || 1}`,
            optionCode: `OPTION${field.options?.length + 1 || 1}`
          };
          return {
            ...field,
            options: [...(field.options || []), newOption]
          };
        }
        return field;
      })
    );
  };

  const deleteOption = (optionId) => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          return {
            ...field,
            options: field.options.filter(opt => opt.id !== optionId)
          };
        }
        return field;
      })
    );
  };

  const editOption = (optionId, type, newValue) => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          return {
            ...field,
            options: field.options.map(opt =>
              opt.id === optionId ? { ...opt, [type]: newValue } : opt
            )
          };
        }
        return field;
      })
    );
  };

  const addReferenceRangeLowerLimitOption = () => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          const newOption = {
            id: Math.floor(1000000000 + Math.random() * 9000000000),
            option: `Option ${field.referenceRangeLowerLimitOptions?.length + 1 || 1}`
          };
          return {
            ...field,
            referenceRangeLowerLimitOptions: [...(field.referenceRangeLowerLimitOptions || []), newOption]
          };
        }
        return field;
      })
    );
  };

  const deleteReferenceRangeLowerLimitOption = (optionId) => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          return {
            ...field,
            referenceRangeLowerLimitOptions: field.referenceRangeLowerLimitOptions.filter(opt => opt.id !== optionId)
          };
        }
        return field;
      })
    );
  };

  const editReferenceRangeLowerLimitOption = (optionId, newValue) => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          return {
            ...field,
            referenceRangeLowerLimitOptions: field.referenceRangeLowerLimitOptions.map(opt =>
              opt.id === optionId ? { ...opt, option: newValue } : opt
            )
          };
        }
        return field;
      })
    );
  };

  const addReferenceRangeUpperLimitOption = () => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          const newOption = {
            id: Math.floor(1000000000 + Math.random() * 9000000000),
            option: `Option ${field.referenceRangeUpperLimitOptions?.length + 1 || 1}`
          };
          return {
            ...field,
            referenceRangeUpperLimitOptions: [...(field.referenceRangeUpperLimitOptions || []), newOption]
          };
        }
        return field;
      })
    );
  };

  const deleteReferenceRangeUpperLimitOption = (optionId) => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          return {
            ...field,
            referenceRangeUpperLimitOptions: field.referenceRangeUpperLimitOptions.filter(opt => opt.id !== optionId)
          };
        }
        return field;
      })
    );
  };

  const editReferenceRangeUpperLimitOption = (optionId, newValue) => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          return {
            ...field,
            referenceRangeUpperLimitOptions: field.referenceRangeUpperLimitOptions.map(opt =>
              opt.id === optionId ? { ...opt, option: newValue } : opt
            )
          };
        }
        return field;
      })
    );
  };

  const addReferenceRangeIndicatorOption = () => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          const newOption = {
            id: Math.floor(1000000000 + Math.random() * 9000000000),
            option: `Option ${field.referenceRangeIndicatorOptions?.length + 1 || 1}`,
            disable: `no`
          };
          return {
            ...field,
            referenceRangeIndicatorOptions: [...(field.referenceRangeIndicatorOptions || []), newOption]
          };
        }
        return field;
      })
    );
  };

  const deleteReferenceRangeIndicatorOption = (optionId) => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          return {
            ...field,
            referenceRangeIndicatorOptions: field.referenceRangeIndicatorOptions.filter(opt => opt.id !== optionId)
          };
        }
        return field;
      })
    );
  };

  const editReferenceRangeIndicatorOption = (optionId, type, newValue) => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id === fieldData.id) {
          return {
            ...field,
            referenceRangeIndicatorOptions: field.referenceRangeIndicatorOptions.map(opt =>
              opt.id === optionId ? { ...opt, [type]: newValue } : opt
            )
          };
        }
        return field;
      })
    );
  };

  const handleCheckboxChange = (checked, itemId) => {
    if (checked) {
      setSelectedItems((prev) => [...prev, itemId]);
    } else {
      setSelectedItems((prev) => prev.filter((id) => id !== itemId));
    }
  };

  const handleSelectAllChange = (checked) => {
    if (checked) {
      const allIds = formFields.map((item) => item.id);
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const getFieldsUsedInConditionalFields = (fields, fieldData) => {
    return fields.map(field => {
      if (![...new Set(field?.conditionalFields?.map(fieldId => Number(fieldId.split('_')[0])))]?.includes(fieldData.id)) {
        return {
          id: field?.id,
        };
      }
    }).filter(Boolean)
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: '700px' }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
          >
            {fieldData?.fieldName} Customization
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <div className="hstack">
            <button
              className={`w-100 border border-start-0 border-muted rounded-0 btn p-2 ${activeTab === "general"
                ? "selectedMenu"
                : "btn-outline-secondary"
                }`}
              style={{ fontSize: 13 }}
              onClick={() => setActiveTab("general")}
            >
              General
            </button>
            {fieldData?.customField === "no" && !(fieldData === "heading" || fieldData === "range" || fieldData === "file" || fieldData === "scale") &&
              <button
                className={`w-100 border border-start-0 border-muted rounded-0 btn p-2 ${activeTab === "fieldGroup"
                  ? "selectedMenu"
                  : "btn-outline-secondary"
                  }`}
                style={{ fontSize: 13 }}
                onClick={() => setActiveTab("fieldGroup")}
              >
                Field Group
              </button>
            }
            {fieldData?.customField === "yes" &&
              <button
                className={`w-100 border border-start-0 border-muted rounded-0 btn p-2 ${activeTab === "customField"
                  ? "selectedMenu"
                  : "btn-outline-secondary"
                  }`}
                style={{ fontSize: 13 }}
                onClick={() => setActiveTab("customField")}
              >
                Custom Field
              </button>
            }
            {fieldData?.type !== "heading" &&
              <button
                className={`w-100 border border-start-0 border-muted rounded-0 btn p-2 ${activeTab === "validation"
                  ? "selectedMenu"
                  : "btn-outline-secondary"
                  }`}
                style={{ fontSize: 13 }}
                onClick={() => setActiveTab("validation")}
              >
                Validation
              </button>
            }
            <button
              className={`w-100 border border-start-0 border-muted rounded-0 btn p-2 ${activeTab === "customization"
                ? "selectedMenu"
                : "btn-outline-secondary"
                }`}
              style={{ fontSize: 13 }}
              onClick={() => setActiveTab("customization")}
            >
              Customization
            </button>
          </div>
          <div
            className="pt-3 overflow-auto"
            style={{ height: "calc(100vh - 81px)" }}
          >
            {activeTab === "general" ? (
              <Container fluid>
                <Row>
                  <Form.Group as={Col} md={fieldData?.type !== "heading" ? 6 : 12} className="mb-2">
                    <Form.Label className="mb-1 fw-bold">
                      <div className="hstack gap-2">
                        <Form.Label className="mb-0 fw-bold">
                          {fieldData?.type !== "heading" ? "Field Label" : "Heading"} <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Check
                          type="switch"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "fieldLabelType", e.target.checked)}
                          checked={!!fieldData?.fieldLabelType}
                        />
                      </div>
                    </Form.Label>
                    <Form.Control
                      placeholder={fieldData?.type !== "heading" ? "Enter Field Label" : "Enter Heading"}
                      type="text"
                      disabled={fieldData?.fieldLabelType}
                      onChange={(e) => handleUpdateFormField(fieldData?.id, "fieldLabel", e.target.value)}
                      value={fieldData?.fieldLabelType ? "" : fieldData?.fieldLabel || ""}
                    />
                  </Form.Group>
                  {fieldData?.type !== "heading" &&
                    <Form.Group as={Col} md={6} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        Field Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        placeholder="Enter Field Name"
                        type="text"
                        onChange={(e) => {
                          const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                          handleUpdateFormField(fieldData?.id, "fieldName", input);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === " ") {
                            e.preventDefault();
                          }
                        }}
                        className={formFields?.find(item => ((item.id !== fieldData?.id) && (item.fieldName === fieldData?.fieldName))) && "border-danger"}
                        value={fieldData?.fieldName || ""}
                      />
                    </Form.Group>
                  }
                  {fieldData?.fieldLabelType &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        {fieldData?.type !== "heading" ? "Field Label" : "Heading"} <span className="text-danger">*</span>
                      </Form.Label>
                      <Editor
                        value={fieldData?.fieldLabel} onChange={(e) => handleUpdateFormField(fieldData?.id, 'fieldLabel', e.target.value)}
                      />
                    </Form.Group>
                  }
                  {(fieldData?.type === "text" ||
                    fieldData?.type === "textarea" ||
                    fieldData?.type === "number") && (
                      <Form.Group as={Col} md={12} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Field Placeholder <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          placeholder="Enter Placeholder"
                          type="text"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "fieldPlaceholder", e.target.value)}
                          value={fieldData?.fieldPlaceholder || ""}
                        />
                      </Form.Group>
                    )}
                  {fieldData?.type !== "heading" &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        Field Help
                      </Form.Label>
                      <Form.Control
                        placeholder="Enter Field Label"
                        as="textarea"
                        onChange={(e) => handleUpdateFormField(fieldData?.id, "fieldHelp", e.target.value)}
                        value={fieldData?.fieldHelp || ""}
                        rows={3}
                      />
                    </Form.Group>
                  }
                  {customForm === "tenderSwallen" &&
                    <>
                      <Form.Group as={Col} md={6} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Position
                        </Form.Label>
                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "fieldPosition", e.target.value)}
                        >
                          <option selected={fieldData?.fieldPosition === ""} value="">No</option>
                          <option selected={fieldData?.fieldPosition === "left"} value="left">Left</option>
                          <option selected={fieldData?.fieldPosition === "right"} value="right">Right</option>
                          <option selected={fieldData?.fieldPosition === "bilateral"} value="bilateral">Bilateral</option>
                        </Form.Select>
                      </Form.Group>
                      <Form.Group as={Col} md={6} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Field Category
                        </Form.Label>
                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "fieldCategory", e.target.value)}
                        >
                          <option selected={fieldData?.fieldCategory === ""} value="">No</option>
                          <option selected={fieldData?.fieldCategory === "tender"} value="tender">Tender</option>
                          <option selected={fieldData?.fieldCategory === "swallen"} value="swallen">Swallen</option>
                        </Form.Select>
                      </Form.Group>
                    </>
                  }
                  {fieldData?.type === "score" &&
                    <>
                      <Form.Group as={Col} md={6} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Score Type
                        </Form.Label>
                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "scoreType", e.target.value)}
                        >
                          <option selected={fieldData?.scoreType === "value"} value="value">Value</option>
                          <option selected={fieldData?.scoreType === "percentage"} value="percentage">Percentage (%)</option>
                        </Form.Select>
                      </Form.Group>
                      <Form.Group as={Col} md={6} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Start Score
                        </Form.Label>
                        <Form.Control
                          placeholder="Enter Start Score"
                          type="number"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "startScore", e.target.value)}
                          value={fieldData?.startScore || 0}
                          rows={3}
                        />
                      </Form.Group>
                      <Form.Group as={Col} md={6} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          End Score
                        </Form.Label>
                        <Form.Control
                          placeholder="Enter End Score"
                          type="number"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "endScore", e.target.value)}
                          value={fieldData?.endScore || 0}
                          rows={3}
                        />
                      </Form.Group>
                      <Form.Group as={Col} md={6} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Box Column
                        </Form.Label>
                        <Form.Control
                          placeholder="Enter Box Column"
                          type="number"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "boxColumn", e.target.value)}
                          value={fieldData?.boxColumn || 0}
                          rows={3}
                        />
                      </Form.Group>
                    </>
                  }
                  {fieldData?.type === "number" &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        Number Type <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        style={{ fontSize: 12 }}
                        className="br3"
                        onChange={(e) => {
                          handleUpdateFormField(fieldData?.id, "numberType", e.target.value);
                          handleUpdateFormField(fieldData?.id, "fixedDecimal", e.target.value === "float" ? 2 : "");
                        }}
                      >
                        <option selected={fieldData?.numberType === ""} value="">Select Number Type</option>
                        <option selected={fieldData?.numberType === "whole"} value="whole">Whole Number</option>
                        <option selected={fieldData?.numberType === "float"} value="float">Float Number</option>
                      </Form.Select>
                    </Form.Group>
                  }
                  {fieldData?.numberType === "float" && (
                    <Form.Group as={Col} md={12} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        Fixed Decimal Number <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        placeholder="Enter Fixed Decimal Number"
                        type="number"
                        onChange={(e) => handleUpdateFormField(fieldData?.id, "fixedDecimal", e.target.value)}
                        value={fieldData?.fixedDecimal || ""}
                      />
                    </Form.Group>
                  )}
                  {!(fieldData?.type === "heading" || fieldData?.type === "file" || fieldData?.type === "scale" || fieldData?.type === "range" || fieldData?.type === "textarea" || fieldData?.type === "score") &&
                    <>
                      <Form.Group as={Col} md={12} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Unique Key <span className="text-danger">*</span>
                        </Form.Label>

                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => {
                            handleUpdateFormField(fieldData?.id, "uniqueKey", e.target.value);
                            handleUpdateFormField(fieldData?.id, "eventKey", "yes");
                            handleUpdateFormField(fieldData?.id, "timePointKey", "no");
                          }
                          }
                        >
                          <option selected={fieldData?.uniqueKey === "no"} value="no">No</option>
                          <option selected={fieldData?.uniqueKey === "yes"} value="yes">Yes</option>
                        </Form.Select>
                      </Form.Group>
                      {fieldData?.uniqueKey === "yes" &&
                        <>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Event Key <span className="text-danger">*</span>
                            </Form.Label>

                            <Form.Select
                              style={{ fontSize: 12 }}
                              className="br3"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "eventKey", e.target.value)}
                            >
                              <option selected={fieldData?.eventKey === "yes"} value="yes">Yes</option>
                              <option selected={fieldData?.eventKey === "no"} value="no">No</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Time Point Key <span className="text-danger">*</span>
                            </Form.Label>

                            <Form.Select
                              style={{ fontSize: 12 }}
                              className="br3"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "timePointKey", e.target.value)}
                            >
                              <option selected={fieldData?.timePointKey === "yes"} value="yes">Yes</option>
                              <option selected={fieldData?.timePointKey === "no"} value="no">No</option>
                            </Form.Select>
                          </Form.Group>
                        </>
                      }
                    </>
                  }
                  {!(fieldData?.type === "heading" || fieldData?.type === "file" || fieldData?.type === "scale" || fieldData?.type === "range" || fieldData?.type === "textarea" || fieldData?.type === "score") &&
                    <Form.Group as={Col} md={6} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        Custom Field <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        style={{ fontSize: 12 }}
                        className="br3"
                        onChange={(e) => {
                          handleUpdateFormField(fieldData?.id, "customField", e.target.value);
                          handleUpdateFormField(fieldData?.id, "groupField", "no");
                          handleUpdateFormField(fieldData?.id, "categoryLabel", "");
                          handleUpdateFormField(fieldData?.id, "categoryName", "");
                          handleUpdateFormField(fieldData?.id, "categoryCodeLabel", "");
                          handleUpdateFormField(fieldData?.id, "categoryCodeName", "");
                          handleUpdateFormField(fieldData?.id, "categoryValueLabel", "");
                          handleUpdateFormField(fieldData?.id, "categoryValueName", "");
                          handleUpdateFormField(fieldData?.id, "categoryUnitLabel", "");
                          handleUpdateFormField(fieldData?.id, "categoryUnitName", "");
                          handleUpdateFormField(fieldData?.id, "categoryRemarkLabel", "");
                          handleUpdateFormField(fieldData?.id, "categoryRemarkName", "");
                          handleUpdateFormField(fieldData?.id, "customFieldViewType", e.target.value === "no" ? "" : "column");
                          handleUpdateFormField(fieldData?.id, "testLabel", "");
                          handleUpdateFormField(fieldData?.id, "testName", "");
                          handleUpdateFormField(fieldData?.id, "testValueLabel", "");
                          handleUpdateFormField(fieldData?.id, "testValueName", "");
                          handleUpdateFormField(fieldData?.id, "testUnitLabel", "");
                          handleUpdateFormField(fieldData?.id, "testUnitName", "");
                          handleUpdateFormField(fieldData?.id, "testLowerRangeLabel", "");
                          handleUpdateFormField(fieldData?.id, "testLowerRangeName", "");
                          handleUpdateFormField(fieldData?.id, "testUpperRangeLabel", "");
                          handleUpdateFormField(fieldData?.id, "testUpperRangeName", "");
                          handleUpdateFormField(fieldData?.id, "testRangeIndicatorLabel", "");
                          handleUpdateFormField(fieldData?.id, "testRangeIndicatorName", "");
                          handleUpdateFormField(fieldData?.id, "testClinicalSignificanceLabel", "");
                          handleUpdateFormField(fieldData?.id, "testClinicalSignificanceName", "");
                          handleUpdateFormField(fieldData?.id, "testCommentLabel", "");
                          handleUpdateFormField(fieldData?.id, "testCommentName", "");
                          handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimit", e.target.value);
                          handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimit", e.target.value);
                          handleUpdateFormField(fieldData?.id, "referenceRangeIndicator", e.target.value);
                          handleUpdateFormField(fieldData?.id, "clinicalSignificance", e.target.value);
                          handleUpdateFormField(fieldData?.id, "customRemark", e.target.value);
                          handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitType", e.target.value === "no" ? "" : "text");
                          handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitLabel", e.target.value === "no" ? "" : `${domainLabel || ""} Reference Range Lower Limit`);
                          handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitName", e.target.value === "no" ? "" : `${domainCode || ""}ORNRLO`);
                          handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitPlaceholder", e.target.value === "no" ? "" : `Enter ${domainLabel || ""} Reference Range Lower Limit`);
                          handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitOptions", []);
                          handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitType", e.target.value === "no" ? "" : "text");
                          handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitLabel", e.target.value === "no" ? "" : `${domainLabel || ""} Reference Range Upper Limit`);
                          handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitName", e.target.value === "no" ? "" : `${domainCode || ""}ORNRHI`);
                          handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitPlaceholder", e.target.value === "no" ? "" : `Enter ${domainLabel || ""} Reference Range Upper Limit`);
                          handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitOptions", []);
                          handleUpdateFormField(fieldData?.id, "referenceRangeIndicatorLabel", e.target.value === "no" ? "" : `${domainLabel || ""} Reference Range Indicator`);
                          handleUpdateFormField(fieldData?.id, "referenceRangeIndicatorName", e.target.value === "no" ? "" : `${domainCode || ""}ORNRIND`);
                          handleUpdateFormField(fieldData?.id, "referenceRangeIndicatorOptions", [
                            {
                              id: Math.floor(1000000000 + Math.random() * 9000000000),
                              option: "Normal",
                              disable: "yes"
                            },
                            {
                              id: Math.floor(1000000000 + Math.random() * 9000000000),
                              option: "Abnormal",
                              disable: "no"
                            }
                          ]);
                          handleUpdateFormField(fieldData?.id, "clinicalSignificanceLabel", e.target.value === "no" ? "" : `${domainLabel || ""} Clinical Significance Label`);
                          handleUpdateFormField(fieldData?.id, "clinicalSignificanceName", e.target.value === "no" ? "" : `${domainCode || ""}CLSIG`);
                          handleUpdateFormField(fieldData?.id, "customRemarkLabel", e.target.value === "no" ? "" : `${domainLabel || ""} Remark`);
                          handleUpdateFormField(fieldData?.id, "customRemarkName", e.target.value === "no" ? "" : `${domainCode || ""}COM`);
                          handleUpdateFormField(fieldData?.id, "customRemarkPlaceholder", e.target.value === "no" ? "" : `Enter ${domainLabel || ""} Remark`);
                          if ((fieldData?.type === "text" || fieldData?.type === "number")) {
                            handleUpdateFormField(fieldData?.id, "fieldDerivation", "no");
                          }
                          if (fieldData?.type === "number") {
                            handleUpdateFormField(fieldData?.id, "autoIncreament", "no");
                            handleUpdateFormField(fieldData?.id, "conditionalFormKey", "no");
                          }
                        }
                        }
                      >
                        <option selected={fieldData?.customField === "yes"} value="yes">Yes</option>
                        <option selected={fieldData?.customField === "no"} value="no">No</option>
                      </Form.Select>
                    </Form.Group>
                  }
                  {fieldData?.type === "number" &&
                    <>
                      {fieldData?.customField === "no" &&
                        <Form.Group as={Col} md={6} className="mb-2">
                          <Form.Label className="mb-1 fw-bold">
                            Auto Increament <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Select
                            style={{ fontSize: 12 }}
                            className="br3"
                            onChange={(e) => { handleUpdateFormField(fieldData?.id, "autoIncreament", e.target.value); handleUpdateFormField(fieldData?.id, "fieldDerivation", e.target.value === "yes" ? "no" : "yes") }}
                          >
                            <option selected={fieldData?.autoIncreament === "yes"} value="yes">Yes</option>
                            <option selected={fieldData?.autoIncreament === "no"} value="no">No</option>
                          </Form.Select>
                        </Form.Group>
                      }
                      {(fieldData?.customField === "no" && fieldData?.autoIncreament === "yes") &&
                        <Form.Group as={Col} md={12} className="mb-2">
                          <Form.Label className="mb-1 fw-bold">
                            Conditional Form Key <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Select
                            style={{ fontSize: 12 }}
                            className="br3"
                            disabled={!conditional}
                            onChange={(e) => { handleUpdateFormField(fieldData?.id, "conditionalFormKey", e.target.value); handleUpdateFormField(fieldData?.id, "conditionalForm", "") }}
                          >
                            <option selected={fieldData?.conditionalFormKey === "yes"} value="yes">Yes</option>
                            <option selected={fieldData?.conditionalFormKey === "no"} value="no">No</option>
                          </Form.Select>
                        </Form.Group>
                      }
                      {(fieldData?.customField === "no" && fieldData?.conditionalFormKey === "yes" && fieldData?.autoIncreament === "yes") &&
                        <Form.Group as={Col} md={12} className="mb-2">
                          <Form.Label className="mb-1 fw-bold">
                            Conditional Form <span className="text-danger">*</span>
                          </Form.Label>
                          {loading ? (
                            <div
                              className="hstack justify-content-center"
                              style={{ height: "calc(100vh - 650px)" }}
                            >
                              <PageLoader />
                            </div>
                          ) : formKeyList?.length === 0 ? (
                            <div
                              className="hstack justify-content-center"
                              style={{ height: "calc(100vh - 650px)" }}
                            >
                              <NoDataFoundTable MSG={"Conditional Form not found!"} />
                            </div>
                          ) :
                            <Table className="m-0 custom-table" hover striped>
                              <thead className="position-sticky top-0 z-1">
                                <tr>
                                  <th
                                    style={{ width: 60 }}
                                    className="text-center"
                                  >
                                    Select
                                  </th>
                                  <th>Form Name</th>
                                  <th>Form type</th>
                                  <th>Special Form</th>
                                </tr>
                              </thead>
                              <tbody>
                                {formKeyList?.map((item, index) => (
                                  <tr onClick={(e) => handleUpdateFormField(fieldData?.id, "conditionalForm", item?.formId)} className="CP" key={index}>
                                    <td className="text-center">
                                      <Form.Check
                                        type="radio"
                                        name="radioGroup"
                                        value={item?.formId}
                                        onChange={(e) => handleUpdateFormField(fieldData?.id, "conditionalForm", e.target.value)}
                                        checked={fieldData?.conditionalForm === item?.formId}
                                      />
                                    </td>
                                    <td>{item?.formName}</td>
                                    <td className="text-capitalize">{item?.formType}</td>
                                    <td className="text-capitalize">{item?.specialForm}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          }
                        </Form.Group>
                      }
                    </>
                  }
                  {(fieldData?.type == "radio" || fieldData?.type == "dropdown" || fieldData?.type === "number") &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        Field Factor <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        style={{ fontSize: 12 }}
                        className="br3"
                        onChange={(e) => handleUpdateFormField(fieldData?.id, "fieldFactor", e.target.value)}
                      >
                        <option selected={fieldData?.fieldFactor === "no"} value="no">No</option>
                        <option selected={fieldData?.fieldFactor === "yes"} value="yes">Yes</option>
                      </Form.Select>
                    </Form.Group>
                  }
                  {fieldData?.autoIncreament !== "yes" && (fieldData?.type !== "file") &&
                    <Form.Group as={Col} md={(fieldData?.type == "text" || fieldData?.type === "number") ? 6 : 12} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        Field Derivation <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        style={{ fontSize: 12 }}
                        className="br3"
                        onChange={(e) => handleUpdateFormField(fieldData?.id, "fieldDerivation", e.target.value)}
                      >
                        <option selected={fieldData?.fieldDerivation === "no"} value="no">No Field Derivation</option>
                        <option selected={fieldData?.fieldDerivation === "assigned"} value="assigned">Assigned</option>
                        <option selected={fieldData?.fieldDerivation === "derived"} value="derived">Derived</option>
                      </Form.Select>
                    </Form.Group>
                  }
                  {fieldData?.type === "date" &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        Date Format <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        style={{ fontSize: 12 }}
                        className="br3"
                        onChange={(e) => handleUpdateFormField(fieldData?.id, "dateFormat", e.target.value)}
                      >
                        <option selected={fieldData?.dateFormat === "YYYY_MMM_DD"} value="YYYY_MMM_DD">YYYYMMMDD</option>
                        <option selected={fieldData?.dateFormat === "DD_MMM_YYYY"} value="DD_MMM_YYYY">DDMMMYYYY</option>
                        <option selected={fieldData?.dateFormat === "DD/MMM/YYYY"} value="DD/MMM/YYYY">DD/MMM/YYYY</option>
                        <option selected={fieldData?.dateFormat === "YYYY/MMM/DD"} value="YYYY/MMM/DD">YYYY/MMM/DD</option>
                        <option selected={fieldData?.dateFormat === "DD-MMM-YYYY"} value="DD-MMM-YYYY">DD-MMM-YYYY</option>
                        <option selected={fieldData?.dateFormat === "YYYY-MMM-DD"} value="YYYY-MMM-DD">YYYY-MMM-DD</option>
                        <option selected={fieldData?.dateFormat === "DD_MM_YYYY"} value="DD_MM_YYYY">DDMMYYYY</option>
                        <option selected={fieldData?.dateFormat === "YYYY_MM_DD"} value="YYYY_MM_DD">YYYYMMDD</option>
                        <option selected={fieldData?.dateFormat === "DD/MM/YYYY"} value="DD/MM/YYYY">DD/MM/YYYY</option>
                        <option selected={fieldData?.dateFormat === "YYYY/MM/DD"} value="YYYY/MM/DD">YYYY/MM/DD</option>
                        <option selected={fieldData?.dateFormat === "YYYY-MM-DD"} value="YYYY-MM-DD">YYYY-MM-DD</option>
                      </Form.Select>
                    </Form.Group>
                  }
                  {fieldData?.type === "time" &&
                    <>
                      <Form.Group as={Col} md={6} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Time Format <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "timeFormat", e.target.value)}
                        >
                          <option selected={fieldData?.timeFormat === "hhmmss"} value="hhmmss">HH:MM:SS</option>
                          <option selected={fieldData?.timeFormat === "hhmm"} value="hhmm">HH:MM</option>
                        </Form.Select>
                      </Form.Group>
                      <Form.Group as={Col} md={6} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Clock Time Format <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => {
                            handleUpdateFormField(fieldData?.id, "clockTimeFormat", e.target.value);
                            handleUpdateFormField(fieldData?.id, "minAmpmType", e.target.value === "12" ? "am" : "");
                            handleUpdateFormField(fieldData?.id, "maxAmpmType", e.target.value === "12" ? "pm" : "")
                          }}
                        >
                          <option selected={fieldData?.clockTimeFormat === "12"} value="12">12 Hours</option>
                          <option selected={fieldData?.clockTimeFormat === "24"} value="24">24 Hours</option>
                        </Form.Select>
                      </Form.Group>
                    </>
                  }
                  {fieldData?.type === "range" &&
                    <>
                      <Form.Group as={Col} md={6} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Start Range <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          placeholder="Enter Start Range"
                          type="number"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "startRange", e.target.value)}
                          value={fieldData?.startRange || ""}
                        />
                      </Form.Group>
                      <Form.Group as={Col} md={6} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          End Range <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          placeholder="Enter End Range"
                          type="number"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "endRange", e.target.value)}
                          value={fieldData?.endRange || ""}
                        />
                      </Form.Group>
                    </>
                  }
                  {fieldData?.type === "file" &&
                    <Form.Group as={Col} md={(fieldData?.type === "text" || fieldData?.type === "number") ? 6 : 12} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        File Type <span className="text-danger">*</span>
                      </Form.Label>
                      <Multiselect
                        displayValue="label"
                        onKeyPressFn={() => { }}
                        onSearch={() => { }}
                        onSelect={(selectedList) =>
                          handleUpdateFormField(fieldData?.id, "fieldFileType", selectedList)
                        }
                        onRemove={(selectedList) =>
                          handleUpdateFormField(fieldData?.id, "fieldFileType", selectedList)
                        }
                        selectedValues={fieldData?.fieldFileType || []}
                        options={[
                          { label: 'PDF File', value: '.pdf' },
                          { label: 'MP3 File', value: '.mp3' },
                          { label: 'MP4 File', value: '.mp4' },
                          { label: 'PNG File', value: '.png' },
                          { label: 'JPG File', value: '.jpg' },
                          { label: 'JPEG File', value: '.jpeg' },
                          { label: 'ZIP File', value: '.zip' },
                          { label: 'RAR File', value: '.rar' },
                          { label: 'XPT File', value: '.xpt' },
                          { label: 'CSV File', value: '.csv' },
                          { label: 'XLS File', value: '.xls' },
                          { label: 'XLSX File', value: '.xlsx' },
                          { label: 'DOC File', value: '.doc' },
                          { label: 'DOCX File', value: '.docx' },
                          { label: 'PPT File', value: '.ppt' },
                          { label: 'PPTX File', value: '.pptx' },
                          { label: 'TXT File', value: '.txt' },
                        ]}
                      />
                    </Form.Group>
                  }
                  {fieldData?.autoIncreament !== "yes" && (fieldData?.type === "text" || fieldData?.type === "number") &&
                    <Form.Group as={Col} md={fieldData?.customField === "yes" ? 12 : 6} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        Field Unit <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        style={{ fontSize: 12 }}
                        className="br3"
                        onChange={(e) => {
                          handleUpdateFormField(fieldData?.id, "fieldUnit", e.target.value);
                          handleUpdateFormField(fieldData?.id, "fieldUnitLabel", "");
                          handleUpdateFormField(fieldData?.id, "fieldUnitName", "");
                          handleUpdateFormField(fieldData?.id, "fieldUnitHelp", "");
                          handleUpdateFormField(fieldData?.id, "unitOptions", []);
                          handleUpdateFormField(fieldData?.id, "fieldWidthSize", fieldData?.fieldUnit === "yes" ? 100 : 50)
                        }}
                      >
                        <option selected={fieldData?.fieldUnit === "yes"} value="yes">Yes</option>
                        <option selected={fieldData?.fieldUnit === "no"} value="no">No</option>
                      </Form.Select>
                    </Form.Group>
                  }
                  {fieldData?.fieldUnit === "yes" &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <div className="border br3 p-3 bg-light shadow-sm">
                        <Row>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Field Unit Label <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Field Unit Label"
                              type="text"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "fieldUnitLabel", e.target.value)}
                              value={fieldData?.fieldUnitLabel || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Field Unit Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Field Unit Name"
                              type="text"
                              onChange={(e) => {
                                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                handleUpdateFormField(fieldData?.id, "fieldUnitName", input);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === " ") {
                                  e.preventDefault();
                                }
                              }}
                              value={fieldData?.fieldUnitName || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={12} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Field Unit Help
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Field Label"
                              as="textarea"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "fieldUnitHelp", e.target.value)}
                              value={fieldData?.fieldUnitHelp || ""}
                              rows={3}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={12} className="mb-2">
                            <Form.Label className="mb-2 fw-bold">
                              Add Field Unit Option{" "}
                              <IoMdAddCircleOutline
                                className="CP"
                                style={{ fontSize: 15 }}
                                title="Add Unit Option"
                                onClick={addUnitOption}
                              />
                            </Form.Label>
                            {fieldData?.unitOptions?.map((option, index) => (
                              <div key={option.id} className="hstack justify-content-between border-bottom mb-2">
                                <p className="m-0 hstack w-100" style={{ fontSize: 13 }}>
                                  <span style={{ fontSize: 13, fontWeight: 800 }}>{index + 1}.</span>
                                  <Form.Control
                                    placeholder="Enter Field Unit Option"
                                    className="border-0"
                                    onChange={(e) => editUnitOption(option?.id, e.target.value)}
                                    style={{ marginLeft: index === 0 ? 3 : 0 }}
                                    value={option?.option || ""}
                                    type="text"
                                  />
                                </p>
                                <div className="hstack gap-2">
                                  <RiDeleteBin6Line
                                    className="text-danger CP"
                                    title="Delete"
                                    style={{ fontSize: 15 }}
                                    onClick={() => deleteUnitOption(option?.id)}
                                  />
                                </div>
                              </div>
                            ))}
                          </Form.Group>
                        </Row>
                      </div>
                    </Form.Group>
                  }
                  {(fieldData?.type === "radio" || fieldData?.type === "checkbox") &&
                    <>
                      <Form.Group as={Col} md={12} className="mb-2">
                        <Form.Label className="mb-1 fw-bold text-capitalize">
                          Option Show in Column <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => {
                            handleUpdateFormField(fieldData?.id, "optionShowColumn", e.target.value);
                          }}
                        >
                          <option selected={fieldData?.optionShowColumn === "1"} value={1}>Column One</option>
                          <option selected={fieldData?.optionShowColumn === "2"} value={2}>Column Two</option>
                          <option selected={fieldData?.optionShowColumn === "3"} value={3}>Column Three</option>
                        </Form.Select>
                      </Form.Group>
                      <Form.Group as={Col} md={12} className="mb-2">
                        <Form.Label className="mb-1 fw-bold text-capitalize">
                          Option Visible <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => {
                            handleUpdateFormField(fieldData?.id, "radioVisible", e.target.value);
                          }}
                        >
                          <option selected={fieldData?.radioVisible === "vertical"} value="vertical">Vertical</option>
                          <option selected={fieldData?.radioVisible === "horizontal"} value="horizontal">Horizontal</option>
                        </Form.Select>
                      </Form.Group>
                    </>
                  }
                  {(fieldData?.type === "checkbox" ||
                    fieldData?.type === "dropdown" ||
                    fieldData?.type === "radio" ||
                    fieldData?.type === "scale") && (
                      <Form.Group as={Col} md={12} className="mb-2">
                        <Form.Label className="mb-2 fw-bold">
                          Add Field Option{" "}
                          <IoMdAddCircleOutline
                            className="CP"
                            style={{ fontSize: 15 }}
                            title="Add Option"
                            onClick={addOption}
                          />
                        </Form.Label>
                        {fieldData?.options?.map((option, index) => (
                          <>
                            <div key={option.id} className={`hstack justify-content-between border-bottom ${optionId === option?.id ? "mb-0" : "mb-2"}`}>
                              <p className="m-0 hstack w-100" style={{ fontSize: 13 }}>
                                <span style={{ fontSize: 13, fontWeight: 800 }}>{index + 1}.</span>
                                <Form.Control
                                  placeholder="Enter Field Option"
                                  className="border-0"
                                  onChange={(e) => editOption(option?.id, "option", e.target.value)}
                                  style={{ marginLeft: index === 0 ? 3 : 0 }}
                                  value={option?.option || ""}
                                  type="text"
                                />
                                <Form.Control
                                  placeholder="Enter Field Option Name"
                                  className="border-0"
                                  onChange={(e) => {
                                    const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                    editOption(option?.id, "optionCode", input);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === " ") {
                                      e.preventDefault();
                                    }
                                  }}
                                  style={{ marginLeft: index === 0 ? 3 : 0 }}
                                  value={option?.optionCode || ""}
                                  type="text"
                                />
                              </p>
                              <div className="hstack gap-2">
                                {conditional &&
                                  <>
                                    {fieldData?.conditionalFields?.filter(conditionalId => conditionalId === `${conditionalId.split('_')[0]}_${option?.id}`)?.length > 0 ?
                                      <GiLogicGateAnd
                                        className="CP text-danger"
                                        title="Apply Conditional Logic"
                                        style={{ fontSize: 17 }}
                                        onClick={() => setOptionId(optionId === option?.id ? "" : option?.id)}
                                      />
                                      :
                                      <TbLogicAnd
                                        className="CP"
                                        title="Apply Conditional Logic"
                                        style={{ fontSize: 17 }}
                                        onClick={() => setOptionId(optionId === option?.id ? "" : option?.id)}
                                      />
                                    }
                                  </>
                                }
                                <RiDeleteBin6Line
                                  className="text-danger CP"
                                  title="Delete"
                                  style={{ fontSize: 15 }}
                                  onClick={() => deleteOption(option?.id)}
                                />
                              </div>
                            </div>
                            <Collapse in={optionId === option?.id}>
                              <div>
                                <div className="hstack">
                                  <button
                                    className={`w-100 border-0 border-start border-muted rounded-0 btn p-1 ${conditionaLogicTab === "field"
                                      ? "selectedMenu"
                                      : "btn-outline-secondary"
                                      }`}
                                    style={{ fontSize: 13 }}
                                    onClick={() => setConditionaLogicTab("field")}
                                  >
                                    Field Level Condition Logic
                                  </button>
                                  <button
                                    className={`w-100 border-0 border-end border-muted rounded-0 btn p-1 ${conditionaLogicTab === "form"
                                      ? "selectedMenu"
                                      : "btn-outline-secondary"
                                      }`}
                                    style={{ fontSize: 13 }}
                                    onClick={() => setConditionaLogicTab("form")}
                                  >
                                    Form Level Condition Logic
                                  </button>
                                </div>
                                {conditionaLogicTab === "field" ?
                                  <Table className="m-0 custom-table" hover striped>
                                    <thead className="position-sticky top-0 z-1">
                                      <tr>
                                        <th style={{ width: 45 }} className="text-center">
                                          <Form.Check
                                            type="checkbox"
                                            checked={
                                              ([...new Set(fieldData?.conditionalFields?.filter(conditionalId => conditionalId === `${conditionalId.split('_')[0]}_${option?.id}`)?.map(fieldId => fieldId.split('_')[0]))]?.length === getFieldsUsedInConditionalFields(formFields, fieldData).length && [...new Set(fieldData?.conditionalFields?.map(fieldId => Number(fieldId.split('_')[1])))]?.includes(option?.id))
                                            }
                                            onChange={(e) =>
                                              handleUpdateFormField(fieldData?.id, 'selectAllconditionalFields', formFields, option?.id)
                                            }
                                          />
                                        </th>
                                        <th>Field Label</th>
                                        <th>Field Name</th>
                                        <th>Type</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {formFields?.map((item, index) => {
                                        return (
                                          ![...new Set(item?.conditionalFields?.map(fieldId => Number(fieldId.split('_')[0])))]?.includes(fieldData.id) &&
                                          <tr key={index}>
                                            <td className="text-center">
                                              <Form.Check
                                                type="checkbox"
                                                checked={fieldData?.conditionalFields?.includes(`${item.id}_${option?.id}`)}
                                                onChange={(e) =>
                                                  handleUpdateFormField(fieldData?.id, 'conditionalFields', item.id, option?.id)
                                                }
                                              />
                                            </td>
                                            <td>{item?.fieldLabel}</td>
                                            <td>{item?.fieldName}</td>
                                            <td className="text-capitalize">{item?.type}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </Table>
                                  :
                                  <Table className="m-0 custom-table" hover striped>
                                    <thead className="position-sticky top-0 z-1">
                                      <tr>
                                        <th
                                          style={{ width: 45 }}
                                          className="text-center"
                                        >
                                          <Form.Check
                                            type="checkbox"
                                            checked={selectedItems.length === formFields.length && formFields.length > 0}
                                            onChange={(e) => handleSelectAllChange(e.target.checked)}
                                          />
                                        </th>
                                        <th>Form Name</th>
                                        <th>Form type</th>
                                        <th>Special Form</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {formMetadataList?.map((item, index) => (
                                        <tr key={index}>
                                          <td className="text-center">
                                            <Form.Check
                                              type="checkbox"
                                              checked={selectedItems?.includes(item.id)}
                                              onChange={(e) => handleCheckboxChange(e.target.checked, item.id)}
                                            />

                                          </td>
                                          <td>{item?.formName}</td>
                                          <td className="text-capitalize">{item?.formType}</td>
                                          <td className="text-capitalize">{item?.specialForm}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                }
                              </div>
                            </Collapse>
                          </>
                        ))}
                      </Form.Group>
                    )}
                  {(fieldData?.type === "scale" || fieldData?.type === "score" || fieldData?.type === "checkbox" || fieldData?.type === "radio" || fieldData?.type === "range" || fieldData?.type === "dropdown" || fieldData?.type === "file") &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        Remark <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        style={{ fontSize: 12 }}
                        className="br3"
                        onChange={(e) => {
                          handleUpdateFormField(fieldData?.id, "customFieldRemark", e.target.value);
                          handleUpdateFormField(fieldData?.id, "customFieldRemarkLabel", e.target.value === "yes" ? "Remark" : "");
                          handleUpdateFormField(fieldData?.id, "customFieldRemarkName", e.target.value === "yes" ? "REMARK" : "")
                        }}
                      >
                        <option selected={fieldData?.customFieldRemark === "no"} value="no">No</option>
                        <option selected={fieldData?.customFieldRemark === "yes"} value="yes">Yes</option>
                      </Form.Select>
                    </Form.Group>
                  }
                  {fieldData?.customFieldRemark === "yes" &&
                    <>
                      <Form.Group as={Col} md={6} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Remark Label <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          placeholder="Enter Remark Label"
                          type="text"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "customFieldRemarkLabel", e.target.value)}
                          value={fieldData?.customFieldRemarkLabel || ""}
                        />
                      </Form.Group>
                      <Form.Group as={Col} md={6} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Remark Name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          placeholder="Enter Remark Name"
                          type="text"
                          onChange={(e) => {
                            const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                            handleUpdateFormField(fieldData?.id, "customFieldRemarkName", input);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === " ") {
                              e.preventDefault();
                            }
                          }}
                          value={fieldData?.customFieldRemarkName || ""}
                        />
                      </Form.Group>
                    </>
                  }
                  {fieldData?.type !== "heading" &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        Field Review <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        style={{ fontSize: 12 }}
                        className="br3"
                        onChange={(e) => handleUpdateFormField(fieldData?.id, "fieldReview", e.target.value)}
                      >
                        <option selected={fieldData?.fieldReview === "yes"} value="yes">Yes</option>
                        <option selected={fieldData?.fieldReview === "no"} value="no">No</option>
                      </Form.Select>
                    </Form.Group>
                  }
                </Row>
              </Container>
            ) : activeTab === "fieldGroup" ? (
              <Container fluid>
                <Row>
                  <Form.Group as={Col} md={12} className="mb-2">
                    <Form.Label className="mb-1 fw-bold">
                      Group Field Category <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      style={{ fontSize: 12 }}
                      className="br3"
                      onChange={(e) => {
                        handleUpdateFormField(fieldData?.id, "groupField", e.target.value)
                        handleUpdateFormField(fieldData?.id, "customField", "no")
                        handleUpdateFormField(fieldData?.id, "customFieldViewType", "");
                        handleUpdateFormField(fieldData?.id, "testLabel", "");
                        handleUpdateFormField(fieldData?.id, "testName", "");
                        handleUpdateFormField(fieldData?.id, "testValueLabel", "");
                        handleUpdateFormField(fieldData?.id, "testValueName", "");
                        handleUpdateFormField(fieldData?.id, "testUnitLabel", "");
                        handleUpdateFormField(fieldData?.id, "testUnitName", "");
                        handleUpdateFormField(fieldData?.id, "testLowerRangeLabel", "");
                        handleUpdateFormField(fieldData?.id, "testLowerRangeName", "");
                        handleUpdateFormField(fieldData?.id, "testUpperRangeLabel", "");
                        handleUpdateFormField(fieldData?.id, "testUpperRangeName", "");
                        handleUpdateFormField(fieldData?.id, "testRangeIndicatorLabel", "");
                        handleUpdateFormField(fieldData?.id, "testRangeIndicatorName", "");
                        handleUpdateFormField(fieldData?.id, "testClinicalSignificanceLabel", "");
                        handleUpdateFormField(fieldData?.id, "testClinicalSignificanceName", "");
                        handleUpdateFormField(fieldData?.id, "testCommentLabel", "");
                        handleUpdateFormField(fieldData?.id, "testCommentName", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimit", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeIndicator", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeIndicatorLabel", "");
                        handleUpdateFormField(fieldData?.id, "clinicalSignificance", "");
                        handleUpdateFormField(fieldData?.id, "customRemark", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitType", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitLabel", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitName", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitHelp", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitOptions", []);
                        handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitPlaceholder", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitType", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitLabel", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitName", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitHelp", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitPlaceholder", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitOptions", []);
                        handleUpdateFormField(fieldData?.id, "referenceRangeIndicatorLabel", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeIndicatorName", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeIndicatorHelp", "");
                        handleUpdateFormField(fieldData?.id, "referenceRangeIndicatorOptions", []);
                        handleUpdateFormField(fieldData?.id, "clinicalSignificanceLabel", "");
                        handleUpdateFormField(fieldData?.id, "clinicalSignificanceName", "");
                        handleUpdateFormField(fieldData?.id, "clinicalSignificanceHelp", "");
                        handleUpdateFormField(fieldData?.id, "customRemarkLabel", "");
                        handleUpdateFormField(fieldData?.id, "customRemarkName", "");
                        handleUpdateFormField(fieldData?.id, "customRemarkPlaceholder", "");
                      }}
                    >
                      <option selected={fieldData?.groupField === "no"} value="no">No</option>
                      <option selected={fieldData?.groupField === "yes"} value="yes">Yes</option>
                    </Form.Select>
                  </Form.Group>
                  {fieldData?.groupField === "yes" &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <div className="border br3 p-3 bg-light shadow-sm">
                        <Row>
                          {formFieldGroupList?.length > 0 &&
                            <Form.Group as={Col} md={12} className="mb-2">
                              <Form.Label className="mb-1 fw-bold">
                                Field Category <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Select
                                style={{ fontSize: 12 }}
                                className="br3"
                                onChange={(e) => handleChangeFormFieldGroup(e.target.value)}
                              >
                                <option selected={formFieldGroup === ""} value="">Select Field Category</option>
                                {formFieldGroupList?.map((item, index) => ((
                                  <option key={index} selected={item?.categoryId === formFieldGroup} value={item?.categoryId}>{item?.categoryName}-{item?.categoryLabel}</option>
                                )))}
                              </Form.Select>
                            </Form.Group>
                          }
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Category Label <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Category Label"
                              type="text"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "categoryLabel", e.target.value)}
                              value={fieldData?.categoryLabel || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Category Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Category Name"
                              type="text"
                              onChange={(e) => {
                                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                handleUpdateFormField(fieldData?.id, "categoryName", input);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === " ") {
                                  e.preventDefault();
                                }
                              }}
                              value={fieldData?.categoryName || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Category Code Label <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Category Code Label"
                              type="text"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "categoryCodeLabel", e.target.value)}
                              value={fieldData?.categoryCodeLabel || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Category Code Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Category Code Name"
                              type="text"
                              onChange={(e) => {
                                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                handleUpdateFormField(fieldData?.id, "categoryCodeName", input);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === " ") {
                                  e.preventDefault();
                                }
                              }}
                              value={fieldData?.categoryCodeName || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Category Value Label <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Category Value Label"
                              type="text"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "categoryValueLabel", e.target.value)}
                              value={fieldData?.categoryValueLabel || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Category Value Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Category Value Name"
                              type="text"
                              onChange={(e) => {
                                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                handleUpdateFormField(fieldData?.id, "categoryValueName", input);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === " ") {
                                  e.preventDefault();
                                }
                              }}
                              value={fieldData?.categoryValueName || ""}
                            />
                          </Form.Group>
                          {fieldData?.fieldUnit === "yes" &&
                            <>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Category Unit Label <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Category Unit Label"
                                  type="text"
                                  onChange={(e) => handleUpdateFormField(fieldData?.id, "categoryUnitLabel", e.target.value)}
                                  value={fieldData?.categoryUnitLabel || ""}
                                />
                              </Form.Group>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Category Unit Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Category Unit Name"
                                  type="text"
                                  onChange={(e) => {
                                    const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                    handleUpdateFormField(fieldData?.id, "categoryUnitName", input);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === " ") {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={fieldData?.categoryUnitName || ""}
                                />
                              </Form.Group>
                            </>
                          }
                          {fieldData?.customFieldRemark === "yes" &&
                            <>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Category Remark Label <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Category Remark Label"
                                  type="text"
                                  onChange={(e) => handleUpdateFormField(fieldData?.id, "categoryRemarkLabel", e.target.value)}
                                  value={fieldData?.categoryRemarkLabel || ""}
                                />
                              </Form.Group>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Category Remark Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Category Remark Name"
                                  type="text"
                                  onChange={(e) => {
                                    const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                    handleUpdateFormField(fieldData?.id, "categoryRemarkName", input);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === " ") {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={fieldData?.categoryRemarkName || ""}
                                />
                              </Form.Group>
                            </>
                          }
                        </Row>
                      </div>
                    </Form.Group>
                  }
                </Row>
              </Container>
            ) : activeTab === "customField" ? (
              <Container fluid>
                <Row>
                  <Form.Group as={Col} md={12} className="mb-2">
                    <Form.Label className="mb-1 fw-bold">
                      Reference Range Lower Limit <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      style={{ fontSize: 12 }}
                      className="br3"
                      onChange={(e) => handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimit", e.target.value)}
                    >
                      <option selected={fieldData?.referenceRangeLowerLimit === "no"} value="no">No</option>
                      <option selected={fieldData?.referenceRangeLowerLimit === "yes"} value="yes">Yes</option>
                    </Form.Select>
                  </Form.Group>
                  {fieldData?.referenceRangeLowerLimit === "yes" &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <div className="border br3 p-3 bg-light shadow-sm">
                        <Row>
                          <Form.Group as={Col} md={12} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Reference Range Lower Limit Type <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              style={{ fontSize: 12 }}
                              className="br3"
                              onChange={(e) => {
                                handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitType", e.target.value);
                                handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitPlaceholder", (e.target.value === "text" || e.target.value === "number") ? "Enter Reference Range Lower Limit Label" : "")
                                if ((e.target.value === "text" || e.target.value === "number")) {
                                  handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitOptions", [])
                                }
                              }}
                            >
                              <option selected={fieldData?.referenceRangeLowerLimitType === "text"} value="text">Text</option>
                              <option selected={fieldData?.referenceRangeLowerLimitType === "number"} value="number">Number</option>
                              <option selected={fieldData?.referenceRangeLowerLimitType === "dropdown"} value="dropdown">Dropdown</option>
                              <option selected={fieldData?.referenceRangeLowerLimitType === "radio"} value="radio">Radio</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Reference Range Lower Limit Label <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Reference Range Lower Limit"
                              type="text"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitLabel", e.target.value)}
                              value={fieldData?.referenceRangeLowerLimitLabel || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Reference Range Lower Limit Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Reference Range Lower Limit Name"
                              type="text"
                              onChange={(e) => {
                                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitName", input);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === " ") {
                                  e.preventDefault();
                                }
                              }}
                              value={fieldData?.referenceRangeLowerLimitName || ""}
                            />
                          </Form.Group>
                          {(fieldData?.referenceRangeLowerLimitType === "text" || fieldData?.referenceRangeLowerLimitType === "number") &&
                            <Form.Group as={Col} md={12} className="mb-2">
                              <Form.Label className="mb-1 fw-bold">
                                Reference Range Lower Limit Placeholder <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Control
                                placeholder="Enter Reference Range Lower Limit Placeholder"
                                type="text"
                                onChange={(e) => handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitPlaceholder", e.target.value)}
                                value={fieldData?.referenceRangeLowerLimitPlaceholder || ""}
                              />
                            </Form.Group>
                          }
                          <Form.Group as={Col} md={12} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Reference Range Lower Limit Help
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Reference Range Lower Limit Help"
                              as="textarea"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "referenceRangeLowerLimitHelp", e.target.value)}
                              value={fieldData?.referenceRangeLowerLimitHelp || ""}
                              rows={2}
                            />
                          </Form.Group>
                          {(fieldData?.referenceRangeLowerLimitType === "dropdown" || fieldData?.referenceRangeLowerLimitType === "radio") &&
                            <Form.Group as={Col} md={12} className="mb-2">
                              <Form.Label className="mb-2 fw-bold">
                                Add Reference Range Lower Limit Option{" "}
                                <IoMdAddCircleOutline
                                  className="CP"
                                  style={{ fontSize: 15 }}
                                  title="Add Option"
                                  onClick={addReferenceRangeLowerLimitOption}
                                />
                              </Form.Label>
                              {fieldData?.referenceRangeLowerLimitOptions?.map((option, index) => (
                                <div key={option.id} className={`hstack justify-content-between border-bottom ${optionId === option?.id ? "mb-0" : "mb-2"}`}>
                                  <p className="m-0 hstack w-100" style={{ fontSize: 13 }}>
                                    <span style={{ fontSize: 13, fontWeight: 800 }}>{index + 1}.</span>
                                    <Form.Control
                                      placeholder="Enter Field Option"
                                      className="border-0"
                                      onChange={(e) => editReferenceRangeLowerLimitOption(option?.id, e.target.value)}
                                      style={{ marginLeft: index === 0 ? 3 : 0 }}
                                      value={option?.option || ""}
                                      type="text"
                                    />
                                  </p>
                                  <RiDeleteBin6Line
                                    className="text-danger CP"
                                    title="Delete"
                                    style={{ fontSize: 15 }}
                                    onClick={() => deleteReferenceRangeLowerLimitOption(option?.id)}
                                  />
                                </div>
                              ))}
                            </Form.Group>
                          }
                        </Row>
                      </div>
                    </Form.Group>
                  }
                  <Form.Group as={Col} md={12} className="mb-2">
                    <Form.Label className="mb-1 fw-bold">
                      Reference Range Upper Limit <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      style={{ fontSize: 12 }}
                      className="br3"
                      onChange={(e) => handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimit", e.target.value)}
                    >
                      <option selected={fieldData?.referenceRangeUpperLimit === "no"} value="no">No</option>
                      <option selected={fieldData?.referenceRangeUpperLimit === "yes"} value="yes">Yes</option>
                    </Form.Select>
                  </Form.Group>
                  {fieldData?.referenceRangeUpperLimit === "yes" &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <div className="border br3 p-3 bg-light shadow-sm">
                        <Row>
                          <Form.Group as={Col} md={12} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Reference Range Lower Upper Type <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              style={{ fontSize: 12 }}
                              className="br3"
                              onChange={(e) => {
                                handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitType", e.target.value);
                                handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitPlaceholder", (e.target.value === "text" || e.target.value === "number") ? "Enter Reference Range Upper Limit Label" : "");
                                if ((e.target.value === "text" || e.target.value === "number")) {
                                  handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitOptions", []);
                                }
                              }}
                            >
                              <option selected={fieldData?.referenceRangeUpperLimitType === "text"} value="text">Text</option>
                              <option selected={fieldData?.referenceRangeUpperLimitType === "number"} value="number">Number</option>
                              <option selected={fieldData?.referenceRangeUpperLimitType === "dropdown"} value="dropdown">Dropdown</option>
                              <option selected={fieldData?.referenceRangeUpperLimitType === "radio"} value="radio">Radio</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Reference Range Upper Limit Label <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Reference Range Upper Limit"
                              type="text"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitLabel", e.target.value)}
                              value={fieldData?.referenceRangeUpperLimitLabel || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Reference Range Upper Limit Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Reference Range Upper Limit Name"
                              type="text"
                              onChange={(e) => {
                                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitName", input);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === " ") {
                                  e.preventDefault();
                                }
                              }}
                              value={fieldData?.referenceRangeUpperLimitName || ""}
                            />
                          </Form.Group>
                          {(fieldData?.referenceRangeUpperLimitType === "text" || fieldData?.referenceRangeUpperLimitType === "number") &&
                            <Form.Group as={Col} md={12} className="mb-2">
                              <Form.Label className="mb-1 fw-bold">
                                Reference Range Upper Limit Placeholder <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Control
                                placeholder="Enter Reference Range Upper Limit Placeholder"
                                type="text"
                                onChange={(e) => handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitPlaceholder", e.target.value)}
                                value={fieldData?.referenceRangeUpperLimitPlaceholder || ""}
                              />
                            </Form.Group>
                          }
                          <Form.Group as={Col} md={12} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Reference Range Upper Limit Help
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Reference Range Upper Limit Help"
                              as="textarea"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "referenceRangeUpperLimitHelp", e.target.value)}
                              value={fieldData?.referenceRangeUpperLimitHelp || ""}
                              rows={2}
                            />
                          </Form.Group>
                          {(fieldData?.referenceRangeUpperLimitType === "dropdown" || fieldData?.referenceRangeUpperLimitType === "radio") &&
                            <Form.Group as={Col} md={12} className="mb-2">
                              <Form.Label className="mb-2 fw-bold">
                                Add Reference Range Upper Limit Option{" "}
                                <IoMdAddCircleOutline
                                  className="CP"
                                  style={{ fontSize: 15 }}
                                  title="Add Option"
                                  onClick={addReferenceRangeUpperLimitOption}
                                />
                              </Form.Label>
                              {fieldData?.referenceRangeUpperLimitOptions?.map((option, index) => (
                                <div key={option.id} className={`hstack justify-content-between border-bottom ${optionId === option?.id ? "mb-0" : "mb-2"}`}>
                                  <p className="m-0 hstack w-100" style={{ fontSize: 13 }}>
                                    <span style={{ fontSize: 13, fontWeight: 800 }}>{index + 1}.</span>
                                    <Form.Control
                                      placeholder="Enter Field Option"
                                      className="border-0"
                                      onChange={(e) => editReferenceRangeUpperLimitOption(option?.id, e.target.value)}
                                      style={{ marginLeft: index === 0 ? 3 : 0 }}
                                      value={option?.option || ""}
                                      type="text"
                                    />
                                  </p>
                                  <RiDeleteBin6Line
                                    className="text-danger CP"
                                    title="Delete"
                                    style={{ fontSize: 15 }}
                                    onClick={() => deleteReferenceRangeUpperLimitOption(option?.id)}
                                  />
                                </div>
                              ))}
                            </Form.Group>
                          }
                        </Row>
                      </div>
                    </Form.Group>
                  }
                  <Form.Group as={Col} md={12} className="mb-2">
                    <Form.Label className="mb-1 fw-bold">
                      Reference Range Indicator <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      style={{ fontSize: 12 }}
                      className="br3"
                      onChange={(e) => handleUpdateFormField(fieldData?.id, "referenceRangeIndicator", e.target.value)}
                    >
                      <option selected={fieldData?.referenceRangeIndicator === "no"} value="no">No</option>
                      <option selected={fieldData?.referenceRangeIndicator === "yes"} value="yes">Yes</option>
                    </Form.Select>
                  </Form.Group>
                  {fieldData?.referenceRangeIndicator === "yes" &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <div className="border br3 p-3 bg-light shadow-sm">
                        <Row>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Reference Range Indicator Label <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Reference Range Indicator"
                              type="text"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "referenceRangeIndicatorLabel", e.target.value)}
                              value={fieldData?.referenceRangeIndicatorLabel || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Reference Range Indicator Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Reference Range Indicator Name"
                              type="text"
                              onChange={(e) => {
                                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                handleUpdateFormField(fieldData?.id, "referenceRangeIndicatorName", input);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === " ") {
                                  e.preventDefault();
                                }
                              }}
                              value={fieldData?.referenceRangeIndicatorName || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={12} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Reference Range Indicator Help
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Reference Range Indicator Help"
                              as="textarea"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "referenceRangeIndicatorHelp", e.target.value)}
                              value={fieldData?.referenceRangeIndicatorHelp || ""}
                              rows={2}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={12} className="mb-2">
                            <Form.Label className="mb-2 fw-bold">
                              Add Reference Range Indicator Option{" "}
                              <IoMdAddCircleOutline
                                className="CP"
                                style={{ fontSize: 15 }}
                                title="Add Option"
                                onClick={addReferenceRangeIndicatorOption}
                              />
                            </Form.Label>
                            {fieldData?.referenceRangeIndicatorOptions?.map((option, index) => (
                              <div key={option.id} className={`hstack justify-content-between border-bottom ${optionId === option?.id ? "mb-0" : "mb-2"}`}>
                                <p className="m-0 hstack w-100" style={{ fontSize: 13 }}>
                                  <span style={{ fontSize: 13, fontWeight: 800 }}>{index + 1}.</span>
                                  <Form.Control
                                    placeholder="Enter Field Option"
                                    className="border-0"
                                    onChange={(e) => editReferenceRangeIndicatorOption(option?.id, "option", e.target.value)}
                                    style={{ marginLeft: index === 0 ? 3 : 0 }}
                                    value={option?.option || ""}
                                    type="text"
                                  />
                                </p>
                                <div className="d-flex gap-2">
                                  {option?.disable === "yes" ?
                                    <MdDisabledVisible
                                      className="text-danger CP"
                                      title="Enable for Clinical Significance"
                                      style={{ fontSize: 15 }}
                                      onClick={(e) => editReferenceRangeIndicatorOption(option?.id, "disable", "no")}
                                    />
                                    :
                                    <FaRegCheckCircle
                                      className="text-success CP"
                                      title="Disable for Clinical Significance"
                                      style={{ fontSize: 15 }}
                                      onClick={(e) => editReferenceRangeIndicatorOption(option?.id, "disable", "yes")}
                                    />
                                  }
                                  <RiDeleteBin6Line
                                    className="text-danger CP"
                                    title="Delete"
                                    style={{ fontSize: 15 }}
                                    onClick={() => deleteReferenceRangeIndicatorOption(option?.id)}
                                  />
                                </div>
                              </div>
                            ))}
                          </Form.Group>
                        </Row>
                      </div>
                    </Form.Group>
                  }
                  <Form.Group as={Col} md={12} className="mb-2">
                    <Form.Label className="mb-1 fw-bold">
                      Clinical Significance <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      style={{ fontSize: 12 }}
                      className="br3"
                      onChange={(e) => handleUpdateFormField(fieldData?.id, "clinicalSignificance", e.target.value)}
                    >
                      <option selected={fieldData?.clinicalSignificance === "no"} value="no">No</option>
                      <option selected={fieldData?.clinicalSignificance === "yes"} value="yes">Yes</option>
                    </Form.Select>
                  </Form.Group>
                  {fieldData?.clinicalSignificance === "yes" &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <div className="border br3 p-3 bg-light shadow-sm">
                        <Row>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Clinical Significance Label <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Clinical Significance Label"
                              type="text"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "clinicalSignificanceLabel", e.target.value)}
                              value={fieldData?.clinicalSignificanceLabel || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Clinical Significance Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Clinical Significance Name"
                              type="text"
                              onChange={(e) => {
                                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                handleUpdateFormField(fieldData?.id, "clinicalSignificanceName", input);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === " ") {
                                  e.preventDefault();
                                }
                              }}
                              value={fieldData?.clinicalSignificanceName || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={12} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Clinical Significance Help
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Clinical Significance Help"
                              as="textarea"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "clinicalSignificanceHelp", e.target.value)}
                              value={fieldData?.clinicalSignificanceHelp || ""}
                              rows={2}
                            />
                          </Form.Group>
                        </Row>
                      </div>
                    </Form.Group>
                  }
                  <Form.Group as={Col} md={12} className="mb-2">
                    <Form.Label className="mb-1 fw-bold">
                      Remark <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      style={{ fontSize: 12 }}
                      className="br3"
                      onChange={(e) => handleUpdateFormField(fieldData?.id, "customRemark", e.target.value)}
                    >
                      <option selected={fieldData?.customRemark === "no"} value="no">No</option>
                      <option selected={fieldData?.customRemark === "yes"} value="yes">Yes</option>
                    </Form.Select>
                  </Form.Group>
                  {fieldData?.customRemark === "yes" &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <div className="border br3 p-3 bg-light shadow-sm">
                        <Row>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Remark <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Remark"
                              type="text"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "customRemarkLabel", e.target.value)}
                              value={fieldData?.customRemarkLabel || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Remark Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Remark Name"
                              type="text"
                              onChange={(e) => {
                                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                handleUpdateFormField(fieldData?.id, "customRemarkName", input);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === " ") {
                                  e.preventDefault();
                                }
                              }}
                              value={fieldData?.customRemarkName || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={12} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Remark Placeholder <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Remark Placeholder"
                              type="text"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "customRemarkPlaceholder", e.target.value)}
                              value={fieldData?.customRemarkPlaceholder || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={12} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Remark Help
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Remark Help"
                              as="textarea"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "customRemarkHelp", e.target.value)}
                              value={fieldData?.customRemarkHelp || ""}
                              rows={2}
                            />
                          </Form.Group>
                        </Row>
                      </div>
                    </Form.Group>
                  }
                  <Form.Group as={Col} md={12} className="mb-2">
                    <Form.Label className="mb-1 fw-bold">
                      Custom Field View Type <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      style={{ fontSize: 12 }}
                      className="br3"
                      onChange={(e) => {
                        handleUpdateFormField(fieldData?.id, "customFieldViewType", e.target.value)
                        handleUpdateFormField(fieldData?.id, "testLabel", "");
                        handleUpdateFormField(fieldData?.id, "testName", "");
                        handleUpdateFormField(fieldData?.id, "testValueLabel", "");
                        handleUpdateFormField(fieldData?.id, "testValueName", "");
                        handleUpdateFormField(fieldData?.id, "testUnitLabel", "");
                        handleUpdateFormField(fieldData?.id, "testUnitName", "");
                        handleUpdateFormField(fieldData?.id, "testLowerRangeLabel", "");
                        handleUpdateFormField(fieldData?.id, "testLowerRangeName", "");
                        handleUpdateFormField(fieldData?.id, "testUpperRangeLabel", "");
                        handleUpdateFormField(fieldData?.id, "testUpperRangeName", "");
                        handleUpdateFormField(fieldData?.id, "testRangeIndicatorLabel", "");
                        handleUpdateFormField(fieldData?.id, "testRangeIndicatorName", "");
                        handleUpdateFormField(fieldData?.id, "testClinicalSignificanceLabel", "");
                        handleUpdateFormField(fieldData?.id, "testClinicalSignificanceName", "");
                        handleUpdateFormField(fieldData?.id, "testCommentLabel", "");
                        handleUpdateFormField(fieldData?.id, "testCommentName", "");
                      }}
                    >
                      <option selected={fieldData?.customFieldViewType === "column"} value="column">By Column</option>
                      <option selected={fieldData?.customFieldViewType === "row"} value="row">By Row</option>
                    </Form.Select>
                  </Form.Group>
                  {fieldData?.customFieldViewType === "row" &&
                    <Form.Group as={Col} md={12} className="mb-2">
                      <div className="border br3 p-3 bg-light shadow-sm">
                        <Row>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Test Label <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Test Label"
                              type="text"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "testLabel", e.target.value)}
                              value={fieldData?.testLabel || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Test Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Test Name"
                              type="text"
                              onChange={(e) => {
                                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9_]/g, "");
                                handleUpdateFormField(fieldData?.id, "testName", input);
                              }}
                              value={fieldData?.testName || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Test Value Label <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Test Value Label"
                              type="text"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "testValueLabel", e.target.value)}
                              value={fieldData?.testValueLabel || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Test Value Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Test Value Name"
                              type="text"
                              onChange={(e) => {
                                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9_]/g, "");
                                handleUpdateFormField(fieldData?.id, "testValueName", input);
                              }}
                              value={fieldData?.testValueName || ""}
                            />
                          </Form.Group>
                          {fieldData?.fieldUnit === "yes" &&
                            <>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Test Unit Label <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Test Unit Label"
                                  type="text"
                                  onChange={(e) => handleUpdateFormField(fieldData?.id, "testUnitLabel", e.target.value)}
                                  value={fieldData?.testUnitLabel || ""}
                                />
                              </Form.Group>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Test Unit Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Test Unit Name"
                                  type="text"
                                  onChange={(e) => {
                                    const input = e.target.value.toUpperCase().replace(/[^A-Z0-9_]/g, "");
                                    handleUpdateFormField(fieldData?.id, "testUnitName", input);
                                  }}
                                  value={fieldData?.testUnitName || ""}
                                />
                              </Form.Group>
                            </>
                          }
                          {fieldData?.referenceRangeLowerLimit === "yes" &&
                            <>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Test Lower Range Label <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Test Lower Range Label"
                                  type="text"
                                  onChange={(e) => handleUpdateFormField(fieldData?.id, "testLowerRangeLabel", e.target.value)}
                                  value={fieldData?.testLowerRangeLabel || ""}
                                />
                              </Form.Group>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Test Lower Range Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Test Lower Range Name"
                                  type="text"
                                  onChange={(e) => {
                                    const input = e.target.value.toUpperCase().replace(/[^A-Z0-9_]/g, "");
                                    handleUpdateFormField(fieldData?.id, "testLowerRangeName", input);
                                  }}
                                  value={fieldData?.testLowerRangeName || ""}
                                />
                              </Form.Group>
                            </>
                          }
                          {fieldData?.referenceRangeUpperLimit === "yes" &&
                            <>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Test Upper Range Label <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Test Upper Range Label"
                                  type="text"
                                  onChange={(e) => handleUpdateFormField(fieldData?.id, "testUpperRangeLabel", e.target.value)}
                                  value={fieldData?.testUpperRangeLabel || ""}
                                />
                              </Form.Group>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Test Upper Range Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Test Upper Range Name"
                                  type="text"
                                  onChange={(e) => {
                                    const input = e.target.value.toUpperCase().replace(/[^A-Z0-9_]/g, "");
                                    handleUpdateFormField(fieldData?.id, "testUpperRangeName", input);
                                  }}
                                  value={fieldData?.testUpperRangeName || ""}
                                />
                              </Form.Group>
                            </>
                          }
                          {fieldData?.referenceRangeIndicator === "yes" &&
                            <>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Test Range Indicator Label <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Test Range Indicator Label"
                                  type="text"
                                  onChange={(e) => handleUpdateFormField(fieldData?.id, "testRangeIndicatorLabel", e.target.value)}
                                  value={fieldData?.testRangeIndicatorLabel || ""}
                                />
                              </Form.Group>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Test Range Indicator Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Test Range Indicator Name"
                                  type="text"
                                  onChange={(e) => {
                                    const input = e.target.value.toUpperCase().replace(/[^A-Z0-9_]/g, "");
                                    handleUpdateFormField(fieldData?.id, "testRangeIndicatorName", input);
                                  }}
                                  value={fieldData?.testRangeIndicatorName || ""}
                                />
                              </Form.Group>
                            </>
                          }
                          {fieldData?.clinicalSignificance === "yes" &&
                            <>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Test Clinical Significance Label <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Test Clinical Significance Label"
                                  type="text"
                                  onChange={(e) => handleUpdateFormField(fieldData?.id, "testClinicalSignificanceLabel", e.target.value)}
                                  value={fieldData?.testClinicalSignificanceLabel || ""}
                                />
                              </Form.Group>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Test Clinical Significance Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Test Clinical Significance Name"
                                  type="text"
                                  onChange={(e) => {
                                    const input = e.target.value.toUpperCase().replace(/[^A-Z0-9_]/g, "");
                                    handleUpdateFormField(fieldData?.id, "testClinicalSignificanceName", input);
                                  }}
                                  value={fieldData?.testClinicalSignificanceName || ""}
                                />
                              </Form.Group>
                            </>
                          }
                          {fieldData?.customRemark === "yes" &&
                            <>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Test Comment Label <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Test Comment Label"
                                  type="text"
                                  onChange={(e) => handleUpdateFormField(fieldData?.id, "testCommentLabel", e.target.value)}
                                  value={fieldData?.testCommentLabel || ""}
                                />
                              </Form.Group>
                              <Form.Group as={Col} md={6} className="mb-2">
                                <Form.Label className="mb-1 fw-bold">
                                  Test Comment Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  placeholder="Enter Test Comment Name"
                                  type="text"
                                  onChange={(e) => {
                                    const input = e.target.value.toUpperCase().replace(/[^A-Z0-9_]/g, "");
                                    handleUpdateFormField(fieldData?.id, "testCommentName", input);
                                  }}
                                  value={fieldData?.testCommentName || ""}
                                />
                              </Form.Group>
                            </>
                          }
                        </Row>
                      </div>
                    </Form.Group>
                  }
                </Row>
              </Container>
            ) : activeTab === "validation" ? (
              <Container fluid>
                <Row>
                  {fieldData?.type === "text" &&
                    <>
                      <Form.Group as={Col} md={12} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Manage Text length <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => {
                            handleUpdateFormField(fieldData?.id, "manageTextLength", e.target.value);
                            handleUpdateFormField(fieldData?.id, "maxTextLength", e.target.value === "yes" ? 100 : "")
                          }}
                        >
                          <option selected={fieldData?.manageTextLength === "yes"} value="yes">Yes</option>
                          <option selected={fieldData?.manageTextLength === "no"} value="no">No</option>
                        </Form.Select>
                      </Form.Group>
                      {fieldData?.manageTextLength === "yes" &&
                        <Form.Group as={Col} md={12} className="mb-2">
                          <Form.Label className="mb-1 fw-bold">
                            Max Text Length <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            placeholder="Enter Minimum Text Length"
                            type="number"
                            onChange={(e) => handleUpdateFormField(fieldData?.id, "maxTextLength", e.target.value)}
                            value={fieldData?.maxTextLength || ""}
                          />
                        </Form.Group>
                      }
                    </>
                  }
                  {fieldData?.type === "number" &&
                    <>
                      <Form.Group as={Col} md={12} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Manage Number Range <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "manageNumberRange", e.target.value)}
                        >
                          <option selected={fieldData?.manageNumberRange === "yes"} value="yes">Yes</option>
                          <option selected={fieldData?.manageNumberRange === "no"} value="no">No</option>
                        </Form.Select>
                      </Form.Group>
                      {fieldData?.manageNumberRange === "yes" &&
                        <>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Min Number <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Minimum Number"
                              type="number"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "minNumber", e.target.value)}
                              value={fieldData?.minNumber || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Max Number <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Maximum Number"
                              type="number"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "maxNumber", e.target.value)}
                              value={fieldData?.maxNumber || ""}
                            />
                          </Form.Group>
                        </>
                      }
                    </>
                  }
                  {fieldData?.type === "range" &&
                    <>
                      <Form.Group as={Col} md={12} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Manage Range <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "manageRange", e.target.value)}
                        >
                          <option selected={fieldData?.manageRange === "no"} value="no">No</option>
                          <option selected={fieldData?.manageRange === "yes"} value="yes">Yes</option>
                        </Form.Select>
                      </Form.Group>
                      {fieldData?.manageRange === "yes" &&
                        <>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Min Range <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Minimum Range"
                              type="number"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "minRange", e.target.value)}
                              value={fieldData?.minRange || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Max Range <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Maximum Range"
                              type="number"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "maxRange", e.target.value)}
                              value={fieldData?.maxRange || ""}
                            />
                          </Form.Group>
                        </>
                      }
                    </>
                  }
                  {fieldData?.type === "score" &&
                    <>
                      <Form.Group as={Col} md={12} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Manage Score <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "manageScore", e.target.value)}
                        >
                          <option selected={fieldData?.manageScore === "no"} value="no">No</option>
                          <option selected={fieldData?.manageScore === "yes"} value="yes">Yes</option>
                        </Form.Select>
                      </Form.Group>
                      {fieldData?.manageScore === "yes" &&
                        <>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Min Score <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Minimum Score"
                              type="number"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "minScore", e.target.value)}
                              value={fieldData?.minScore || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              Max Score <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              placeholder="Enter Maximum Score"
                              type="number"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "maxScore", e.target.value)}
                              value={fieldData?.maxScore || ""}
                            />
                          </Form.Group>
                        </>
                      }
                    </>
                  }
                  {fieldData?.type === "date" &&
                    <>
                      <Form.Group as={Col} md={12} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Manage Date Range <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "manageDateRange", e.target.value)}
                        >
                          <option selected={fieldData?.manageDateRange === "yes"} value="yes">Yes</option>
                          <option selected={fieldData?.manageDateRange === "no"} value="no">No</option>
                        </Form.Select>
                      </Form.Group>
                      {fieldData?.manageDateRange === "yes" &&
                        <>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              From <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="date"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "minDate", e.target.value)}
                              value={fieldData?.minDate || ""}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              To <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="date"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "maxDate", e.target.value)}
                              value={fieldData?.maxDate || ""}
                            />
                          </Form.Group>
                        </>
                      }
                    </>
                  }
                  {fieldData?.type === "time" &&
                    <>
                      <Form.Group as={Col} md={12} className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Manage Time Range <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          style={{ fontSize: 12 }}
                          className="br3"
                          onChange={(e) => handleUpdateFormField(fieldData?.id, "manageTimeRange", e.target.value)}
                        >
                          <option selected={fieldData?.manageTimeRange === "yes"} value="yes">Yes</option>
                          <option selected={fieldData?.manageTimeRange === "no"} value="no">No</option>
                        </Form.Select>
                      </Form.Group>
                      {fieldData?.manageTimeRange === "yes" &&
                        <>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              From <span className="text-danger">*</span>
                            </Form.Label>
                            <InputGroup>
                              <Form.Control
                                type="time"
                                {...(fieldData?.timeFormat === "hhmmss" ?
                                  { step: 1 }
                                  : {})}
                                className={fieldData?.clockTimeFormat === "12" && "w-75"}
                                onChange={(e) => handleUpdateFormField(fieldData?.id, "minTime", e.target.value)}
                                value={fieldData?.minTime || ""}
                              />
                              {fieldData?.clockTimeFormat === "12" &&
                                <Form.Select
                                  style={{ fontSize: 12 }}
                                  className="br3 w-25"
                                  onChange={(e) => handleUpdateFormField(fieldData?.id, "minAmpmType", e.target.value)}
                                >
                                  <option selected={fieldData?.minAmpmType === "am"} value="am">AM</option>
                                  <option selected={fieldData?.minAmpmType === "pm"} value="pm">PM</option>
                                </Form.Select>
                              }
                            </InputGroup>
                          </Form.Group>
                          <Form.Group as={Col} md={6} className="mb-2">
                            <Form.Label className="mb-1 fw-bold">
                              To <span className="text-danger">*</span>
                            </Form.Label>
                            <InputGroup>
                              <Form.Control
                                type="time"
                                {...(fieldData?.timeFormat === "hhmmss" ?
                                  { step: 1 }
                                  : {})}
                                className={fieldData?.clockTimeFormat === "12" && "w-75"}
                                onChange={(e) => handleUpdateFormField(fieldData?.id, "maxTime", e.target.value)}
                                value={fieldData?.maxTime || ""}
                              />
                              {fieldData?.clockTimeFormat === "12" &&
                                <Form.Select
                                  style={{ fontSize: 12 }}
                                  className="br3 w-25"
                                  onChange={(e) => handleUpdateFormField(fieldData?.id, "maxAmpmType", e.target.value)}
                                >
                                  <option selected={fieldData?.maxAmpmType === "am"} value="am">AM</option>
                                  <option selected={fieldData?.maxAmpmType === "pm"} value="pm">PM</option>
                                </Form.Select>
                              }
                            </InputGroup>
                          </Form.Group>
                        </>
                      }
                    </>
                  }
                  <Form.Group as={Col} md={12} className="mb-2">
                    <Form.Label className="mb-1 fw-bold">
                      Field Required <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      style={{ fontSize: 12 }}
                      className="br3"
                      onChange={(e) => handleUpdateFormField(fieldData?.id, "fieldMandatory", e.target.value)}
                    >
                      <option selected={fieldData?.fieldMandatory === "yes"} value="yes">Yes</option>
                      <option selected={fieldData?.fieldMandatory === "no"} value="no">No</option>
                    </Form.Select>
                  </Form.Group>
                </Row>
              </Container>
            ) : activeTab === "customization" ? (
              <Container fluid>
                <Row>
                  <Form.Group as={Col} md={6} className="mb-2">
                    <Form.Label className="mb-1 fw-bold">
                      Column Size <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      style={{ fontSize: 12 }}
                      className="br3"
                      onChange={(e) => handleUpdateFormField(fieldData?.id, "columnSize", e.target.value)}
                    >
                      <option selected={Number(fieldData?.columnSize) === 12} value={12}>100% Column</option>
                      <option selected={Number(fieldData?.columnSize) === 8} value={8}>66.67% Column</option>
                      <option selected={Number(fieldData?.columnSize) === 6} value={6}>50% Column</option>
                      <option selected={Number(fieldData?.columnSize) === 4} value={4}>33.33% Column</option>
                      <option selected={Number(fieldData?.columnSize) === 3} value={3}>25% Column</option>
                    </Form.Select>
                  </Form.Group>
                  {fieldData?.customField !== "yes" &&
                    <Form.Group as={Col} md={6} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        Field Width <span className="text-danger">*</span>
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          placeholder={"Enter Field Width Size"}
                          type="number"
                          onChange={(e) => {
                            const value = parseInt(e.target.value, 10);
                            if (value <= (fieldData?.fieldUnit === "yes" ? 50 : 100)) {
                              handleUpdateFormField(fieldData?.id, "fieldWidthSize", value);
                            }
                          }}
                          value={fieldData?.fieldWidthSize || 100}
                        />
                        <InputGroup.Text style={{ fontSize: 12, fontWeight: 600 }}>%</InputGroup.Text>
                      </InputGroup>
                    </Form.Group>
                  }
                  {((fieldData?.type === "text" && fieldData?.fieldUnit === "no") ||
                    (fieldData?.type === "number" && fieldData?.fieldUnit === "no") ||
                    fieldData?.type === "dropdown" ||
                    fieldData?.customFieldRemark === "yes" ||
                    fieldData?.type === "file" ||
                    fieldData?.type === "range" ||
                    fieldData?.type === "textarea") &&
                    <Form.Group as={Col} md={6} className="mb-2">
                      <Form.Label className="mb-1 fw-bold">
                        Input Width <span className="text-danger">*</span>
                      </Form.Label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          placeholder={"Enter Field Width Size"}
                          type="number"
                          onChange={(e) => {
                            const value = parseInt(e.target.value, 10);
                            if (value <= (fieldData?.fieldUnit === "yes" ? 50 : 100)) {
                              handleUpdateFormField(fieldData?.id, "inputWidthSize", value);
                            }
                          }}
                          value={fieldData?.inputWidthSize || 100}
                        />
                        <InputGroup.Text style={{ fontSize: 12, fontWeight: 600 }}>%</InputGroup.Text>
                      </InputGroup>
                    </Form.Group>
                  }
                  <Form.Group as={Col} md={12}>
                    <Form.Label className="mb-1 fw-bold">
                      Label Customization
                    </Form.Label>
                  </Form.Group>
                  <Form.Group as={Col} md={12} className="mb-3">
                    <div className="p-3 border br3 bg-light">
                      <Row>
                        <Form.Group as={Col} md={4} className="mb-2">
                          <div className="hstack gap-2">
                            <Form.Label className="mb-0 fw-bold">
                              Bold
                            </Form.Label>
                            <Form.Check
                              type="switch"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "labelBold", e.target.checked)}
                              checked={!!fieldData?.labelBold}
                            />
                          </div>
                        </Form.Group>
                        <Form.Group as={Col} md={4} className="mb-2">
                          <div className="hstack gap-2">
                            <Form.Label className="mb-0 fw-bold">
                              Italic
                            </Form.Label>
                            <Form.Check
                              type="switch"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "labelItalic", e.target.checked)}
                              checked={!!fieldData?.labelItalic}
                            />
                          </div>
                        </Form.Group>
                        <Form.Group as={Col} md={4} className="mb-2">
                          <div className="hstack gap-2">
                            <Form.Label className="mb-0 fw-bold">
                              Underline
                            </Form.Label>
                            <Form.Check
                              type="switch"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "labelUnderline", e.target.checked)}
                              checked={!!fieldData?.labelUnderline}
                            />
                          </div>
                        </Form.Group>
                        <Form.Group as={Col} md={6} className="mb-2">
                          <div className="hstack gap-2 mb-1">
                            <Form.Label className="mb-0 fw-bold">
                              Label Color
                            </Form.Label>
                          </div>
                          <div className="position-relative">
                            <Form.Control
                              type="text" placeholder="#000000"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "labelColor", e.target.value)}
                              value={fieldData?.labelColor}
                            />
                            <Form.Control
                              type="color"
                              className="p-0 position-absolute"
                              onChange={(e) => handleUpdateFormField(fieldData?.id, "labelColor", e.target.value)}
                              value={fieldData?.labelColor}
                              style={{
                                width: 20,
                                height: 20,
                                right: 5,
                                top: 5,
                              }}
                            />
                          </div>
                        </Form.Group>
                        <Form.Group as={Col} md={6} className="mb-2">
                          <div className="hstack gap-2 mb-1">
                            <Form.Label className="mb-0 fw-bold">
                              Font Size
                            </Form.Label>
                          </div>
                          <div className="position-relative">
                            <InputGroup>
                              <Form.Control
                                type="number"
                                placeholder="35"
                                onChange={(e) => handleUpdateFormField(fieldData?.id, "labelSize", e.target.value)}
                                value={fieldData?.labelSize}
                              />
                              <InputGroup.Text
                                id="basic-addon1"
                                className="br3 fw-bold"
                                style={{ fontSize: 12 }}
                              >
                                PX
                              </InputGroup.Text>
                            </InputGroup>
                          </div>
                        </Form.Group>
                      </Row>
                    </div>
                  </Form.Group>
                </Row>
              </Container>
            ) : (
              ""
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
export default FormCustomization;